import React, { useState } from 'react';
import styled from 'styled-components';

import { media } from '~/utils';

import AnswerIcon from '@public/images/answer.svg';
import QuestionIcon from '@public/images/question.svg';

type Props = {
  question: {
    title: string;
    text: string;
  };
  defaultOpen: boolean;
};

export function Question({ question, defaultOpen }: Props) {
  const [isOpen, setIsOpen] = useState(!!defaultOpen);

  if (!question.text) return null;

  return (
    <Wrapper onClick={() => setIsOpen(!isOpen)}>
      <Title>
        <StyledIconBox>
          <QuestionIcon />
        </StyledIconBox>
        <TitleContent>{question.title}</TitleContent>
      </Title>
      <Text isOpen={isOpen}>
        <StyledIconBox>
          <AnswerIcon />
        </StyledIconBox>
        <TextContent>{question.text}</TextContent>
      </Text>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  cursor: pointer;
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

const StyledIconBox = styled.div`
  > svg {
    aspect-ratio: 80 / 91.4;
    width: 80px;
    height: fit-content;

    ${media.mid`
     width: 50px;
   `}
  }
`;

const TitleContent = styled.div`
  margin-top: 5px;
  margin-left: 40px;
  font-size: 30px;
  font-weight: bold;
  line-height: 48px;
  flex: 1;

  ${media.mid`
    margin-top: -5px;
    font-size: 18px;
    line-height: 32px;
    margin-left: 20px;
  `}
`;

const Text = styled.div<{ isOpen: boolean }>`
  margin-top: 10px;
  display: ${(props) => (props.isOpen ? 'flex' : 'none')};
  flex-directon: row;
  align-items: flex-start;
`;

const TextContent = styled.div`
  margin-top: 14px;
  margin-left: 40px;
  font-size: 18px;
  line-height: 32px;
  white-space: pre-wrap;
  flex: 1;

  ${media.mid`
    margin-top: 0;
    font-size: 16px;
    line-height: 30px;
    margin-left: 20px;
  `}
`;
